export interface ValueCard {
  title: string;
  description: string;
  imageUrl: string;
  imageAlt: string;
}

export const engineeringValues: ValueCard[] = [
  {
    title: 'Clean Architecture',
    description:
      'We follow modern software engineering practices including clean architecture principles to create modular, maintainable, and testable codebases that stand the test of time and adapt gracefully to evolving requirements.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Abstract%20layered%20geometric%20shapes%20in%20monochromatic%20near%20white%20and%20pale%20gray%20tones%2C%20clean%20architectural%20lines%2C%20modular%20block%20diagram%20pattern%2C%20minimalist%20design%2C%20no%20text%2C%20no%20people%2C%20soft%20ambient%20lighting%2C%20subtle%20depth%2C%20editorial%20abstract%20composition&width=600&height=400&seq=vasko-card-arch-01&orientation=landscape',
    imageAlt: 'Layered geometric shapes representing clean architectural design patterns',
  },
  {
    title: 'Performance Optimization',
    description:
      'Every system we build is optimized for speed and efficiency. From algorithm design to resource management, we ensure peak performance across all layers of the technology stack.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Abstract%20topology%20flow%20lines%20and%20speed%20streams%20in%20pale%20warm%20gray%20tones%2C%20dynamic%20data%20flow%20pattern%2C%20minimalist%20design%2C%20no%20text%2C%20no%20people%2C%20soft%20ambient%20lighting%2C%20smooth%20curved%20lines%2C%20editorial%20abstract%20composition%2C%20elegant%20precision&width=600&height=400&seq=vasko-card-perf-02&orientation=landscape',
    imageAlt: 'Abstract topology flow lines representing performance optimization',
  },
  {
    title: 'User-Centered Design',
    description:
      'We place users at the heart of every decision. Our design process prioritizes intuitive interfaces, accessible experiences, and meaningful interactions that deliver real value.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Abstract%20interface%20node%20networks%20and%20connected%20circles%20in%20soft%20cool%20gray%20tones%2C%20interaction%20hub%20pattern%2C%20minimalist%20design%2C%20no%20text%2C%20no%20people%2C%20soft%20ambient%20lighting%2C%20harmonious%20layout%2C%20editorial%20abstract%20composition&width=600&height=400&seq=vasko-card-ux-03&orientation=landscape',
    imageAlt: 'Abstract node networks representing user-centered design interactions',
  },
  {
    title: 'Scalable Systems',
    description:
      'Our solutions are engineered to grow. We design with scalability in mind, ensuring systems remain robust, responsive, and maintainable as demands and complexity increase over time.',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Abstract%20expanding%20grid%20structures%20and%20recursive%20geometric%20patterns%20in%20light%20beige%20tones%2C%20scalable%20network%20topology%2C%20minimalist%20design%2C%20no%20text%2C%20no%20people%2C%20soft%20ambient%20lighting%2C%20growing%20fractal%20pattern%2C%20editorial%20abstract%20composition&width=600&height=400&seq=vasko-card-scale-04&orientation=landscape',
    imageAlt: 'Expanding grid structures representing scalable system architecture',
  },
];